import AlertWithIcon from '@/src/common/components/elements/Alerts/AlertWithIcon'

const ResendGiftCardModalInfo = () => (
    <AlertWithIcon iconName={'info'}>
        <span>
            Before changing the recipient, keep in mind the following
            instructions:
        </span>
        <ul>
            <li>
                Double-check the new recipient&apos;s email and their email
                filter for messages from perfectgift.com before updating their
                information.
            </li>
            <li>
                The previous link won’t be valid after you submit the request.
            </li>
        </ul>
    </AlertWithIcon>
)

export default ResendGiftCardModalInfo
